<template>
  <!-- 充电日数据统计 -->
  <div class="app-container1">
    <div class="leftArea">
      <!-- 搜索框 -->
      <div class="tree-search">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" clearable prefix-icon="el-icon-search">
        </el-input>
        <div class="tree-search-btns">
          <el-button size="small" icon="el-icon-caret-bottom" @click="expandAll">一键展开</el-button>
          <el-button size="small" icon="el-icon-caret-top" @click="collapseAll">一键收缩</el-button>
        </div>
      </div>

      <!-- 树形组件，包含简约滚动功能 -->
      <div class="tree-container" ref="treeContainer">
        <el-tree highlight-current ref="tree" node-key="id" show-checkbox v-loading="treeLoading" :data="treeData"
          @check-change="handleCheckChange" :props="defaultProps" default-expand-all :expand-on-click-node="false"
          :filter-node-method="filterNode"></el-tree>
      </div>
    </div>

    <div class="rightArea">
      <el-form :inline="true" @keyup.enter.native="toFilter">
        <el-form-item label="时间范围">
          <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="handleDateChange"
            clearable></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
          <!-- <el-button   icon="el-icon-plus" type="success"
            @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
        </el-form-item>
      </el-form>

      <div class="charts-container">
        <div class="chart-item">
          <div class="chart-wrapper" ref="devUseElecChart"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts"
import { GetLeftTree } from "@/api/dev_archive"
import { getchargeOrderStatisticDaliyApi } from "@/api/data_statistic"

import { mapGetters } from "vuex"
export default {
  name: "useElecStatistics",
  components: {},
  data() {
    return {
      filterText: "",
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "Text", // 注意：这里对应后端返回的Text字段
      },
      treeData: [
        {
          label: "全部",
          id: "",
          children: [],
        },
      ],

      searchData: {
        site_ids: [], //站点id集合
        start_time: '',
        end_time: '',
      },
      dateRange: [],
      myChart: null, // ECharts 实例
      chartData: {
        xData: [], // X轴数据
        electricity: [],  // Y轴数据-充电量数据
        fee: [],  // Y轴数据-电费数据
        serviceFee: [],  // Y轴数据-服务费数据
      },
      // 限制：不能选择今天之后的日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      selectDateData: [],//选择日期范围组成的对象数组
      dateMap: {}, // 日期映射表（快速查找）
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    //this.showChart()
    // 进入页面默认选中最近一周
    this.setDefaultWeekRange()
    // 1. 初始化图表
    this.initChart()
    // 2. 获取后台数据
    this.getUseElecStatisticDaliy()
  },
  beforeDestroy() {
    // 销毁图表，防止内存泄漏
    if (this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
  methods: {
    /**
     * 1. 默认设置：最近16天（包含今天，今天往前推15天，因为后台返回的数据不含今天，所以实际上显示15天的数据）
     */
    setDefaultWeekRange() {
      const today = new Date()
      const startDate = new Date()
      startDate.setDate(today.getDate() - 15)

      const end = this.formatDate(today)
      const start = this.formatDate(startDate)

      this.dateRange = [start, end]
      this.handleDateChange(this.dateRange)
    },
    // 1. 初始化 ECharts
    initChart() {
      // 获取 DOM 容器
      const chartDom = this.$refs.devUseElecChart
      // 初始化实例
      this.myChart = echarts.init(chartDom)

      const option = {
        title: {
          text: "充电情况统计",
          subtext: "日统计"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: 'shadow' }
        },
        legend: {
          data: ['充电量', '电费', '服务费']
        },
        toolbox: {
          show: true,
          right: 60,
          top: 0,
          itemSize: 16, // 图标尺寸
          itemGap: 12,  // 按钮之间间距
          feature: {
            dataView: { 
              show: true, 
              readOnly: true,
              title: '数据视图',
              optionToContent: function(opt) {
                const xAxisData = opt.xAxis[0].data;
                const series = opt.series;
                let table = '<table style="width:100%;border-collapse: collapse;text-align:center;font-size:13px;">';
                // 表头
                table += '<tr style="background:#eef4ff">';
                table += '<th style="border:1px solid #dcdcdc;padding:10px;width:150px;">日期</th>';
                series.forEach(s => {
                  table += `<th style="border:1px solid #dcdcdc;padding:10px;">${s.name}</th>`;
                });
                table += '</tr>';
                // 数据行循环
                xAxisData.forEach((date, idx) => {
                  table += '<tr>';
                  table += `<td style="border:1px solid #dcdcdc;padding:10px;">${date}</td>`;
                  series.forEach(s => {
                    table += `<td style="border:1px solid #dcdcdc;padding:10px;">${s.data[idx]}</td>`;
                  });
                  table += '</tr>';
                });
                // 合计行：按列累加各 series 数据
                table += '<tr style="background:#f5f7fa;font-weight:600;">';
                table += '<td style="border:1px solid #dcdcdc;padding:10px;">总计</td>';
                series.forEach(s => {
                  const total = s.data.reduce((acc, val) => acc + (Number(val) || 0), 0);
                  table += `<td style="border:1px solid #dcdcdc;padding:10px;">${total.toFixed(2)}</td>`;
                });
                table += '</tr>';
                table += '</table>';
                return table;
              },
              contentStyle: {
                minWidth: '700px'
              }  
            },
            magicType: { show: true, type: ["line", "bar"] },
            /* restore: { show: true },
            saveAsImage: { show: true } */
          }
        },
        //calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: this.chartData.xData // 先为空
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "充电量",
            type: "bar",
            data: this.electricity,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" }
              ]
            },
            barGap: '0%',       // 柱子之间无空隙
            markLine: {
              data: [{ type: "average", name: "Avg" }]
            }
          },
          {
            name: "电费",
            type: "bar",
            data: this.fee,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" }
              ]
            },
            markLine: {
              data: [{ type: "average", name: "Avg" }]
            }
          },
          {
            name: "服务费",
            type: "bar",
            data: this.serviceFee,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" }
              ]
            },
            markLine: {
              data: [{ type: "average", name: "Avg" }]
            }
          },
        ]
      }

      // 设置配置项
      this.myChart.setOption(option)
      // 窗口大小变化时自适应
      window.addEventListener('resize', () => {
        this.myChart.resize()
      })

    },
    handleDateChange(value) {
      if (value && value.length == 2) {
        this.searchData.start_time = value[0]
        this.searchData.end_time = value[1]

        // 生成日期数组
        this.selectDateData = this.generateDateList(this.searchData.start_time, this.searchData.end_time)
        // 构建快速查找 MAP { 日期: 对象 }
        this.dateMap = {}
        this.selectDateData.forEach(item => {
          this.dateMap[item.date] = item
        })
      } else {
        this.searchData.start_time = ''
        this.searchData.end_time = ''

        this.selectDateData = []
        this.dateMap = {}
      }
    },
    // 一键展开树形组件所有节点
    expandAll() {
      const nodes = this.$refs.tree.store._getAllNodes();
      nodes.forEach((node) => {
        node.expanded = true;
      });
    },
    // 一键收缩树形组件所有节点
    collapseAll() {
      const nodes = this.$refs.tree.store._getAllNodes();
      nodes.forEach((node) => {
        node.expanded = false;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      //return data.label.indexOf(value) !== -1;
      // 根据Text字段进行过滤
      return data.Text && data.Text.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, indeterminate) {
      //console.log('点击选中的数据：',data)
      if ((!data.children || data.children.length == 0) && checked) {
        //选中的站点
        this.searchData.site_ids.push(data.id);
      }
      if ((!data.children || data.children.length == 0) && !checked) {
        //取消选中的站点
        //this.searchData.site_ids.pop(data.id);
        const idx = this.searchData.site_ids.indexOf(data.id)
        if (idx !== -1) {
          // splice 会触发视图更新
          this.searchData.site_ids.splice(idx, 1)
        }
      }
    },
    getData() {
      this.treeLoading = true;
      GetLeftTree({
        // 参数根据实际接口需要传递
      })
        .then((res) => {
          this.treeData = res.tree || [];
          //console.log("获取到的树数据:", this.treeData);
        })
        .catch((error) => {
          //console.error("获取树数据失败:", error);
        })
        .finally(() => {
          this.treeLoading = false;
        });
    },
    toFilter() {
      //this.showChart()
      //console.log('日期数据：',this.dateRange)
      this.getUseElecStatisticDaliy()
    },
    getUseElecStatisticDaliy() {
      let requestData = this.searchData
      getchargeOrderStatisticDaliyApi(requestData).then((res) => {
        //console.log('返回图标数据', res)
        const backData = res.data || []
        //console.log(Array.isArray(backData))
        let handleData = backData.map((item) => {
          const date = item.date_str // 日期
          const powerdata = ((item.sharp_power + item.peak_power + item.flat_power + item.valley_power) / 1000).toFixed(2) // 充电量
          const powerFee = ((item.sharp_power_cost + item.peak_power_cost + item.flat_power_cost + item.valley_power_cost) / 10000).toFixed(2)// 电费
          const serviceFee = ((item.sharp_serv_cost + item.peak_serv_cost + item.flat_serv_cost + item.valley_serv_cost) / 10000).toFixed(2) // 服务费

          const target = this.dateMap[item.date_str] // 快速查找
          if (target) {
            target.electricity = powerdata
            target.fee = powerFee
            target.serviceFee = serviceFee
          }
          return {
            date: date,
            electricity: powerdata,
            fee: powerFee,
            serviceFee: serviceFee
          }
        })
        // if(!this.selectDateData || this.selectDateData.length == 0){
        //   this.selectDateData = handleData
        //   //this.$set()
        // }
        this.selectDateData = handleData || []
        if(this.selectDateData && this.selectDateData.length > 0){
          this.chartData.xData = this.selectDateData.map( item => item.date)
          this.chartData.electricity = this.selectDateData.map( item => item.electricity)
          this.chartData.fee = this.selectDateData.map( item => item.fee)
          this.chartData.serviceFee = this.selectDateData.map( item => item.serviceFee)
          
        } else {
          this.chartData.xData = []
          this.chartData.electricity = []
          this.chartData.fee = []
          this.chartData.serviceFee = []
        }
        this.updateChart()
        //console.log('xData',this.chartData.xData)
      }).catch((err) => {
        console.log('数据有误',JSON.stringify(err),err)
      }).finally(() => {

      })
    },
    // 更新图表数据
    updateChart() {
      if (this.myChart) {
        this.myChart.setOption({
          xAxis: { data: this.chartData.xData },
          series: [
            { name: '充电量', data: this.chartData.electricity },
            { name: '电费', data: this.chartData.fee },
            { name: '服务费', data: this.chartData.serviceFee }
          ]
        })
      }
    },
    // 日期格式化 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 生成 开始日期 ~ 结束日期 的对象数组（正序排列）
    generateDateList(startDate, endDate) {
      const dateArray = [];
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 循环遍历每一天
      while (start <= end) {
        const date = this.formatDate(start);

        // 推入标准对象
        dateArray.push({
          date: date,             // 日期
          electricity: 0,         // 充电量 默认0
          fee: 0,                 // 电费 默认0
          serviceFee: 0           // 服务费 默认0
        });

        // 日期 +1天
        start.setDate(start.getDate() + 1);
      }

      // 数组已经是 从小到大 顺序
      return dateArray;
    }


  }
}
</script>



<style scoped lang="scss">
.app-container1 {
  display: flex;
  flex-direction: row;
  height: 87vh;
  border-radius: 5px;
  overflow: hidden;
}

.my-tree {
  position: relative;
  width: 18%;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tree-search {
  margin-bottom: 10px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tree-search-btns {
  display: flex;
  justify-content: space-between;
  gap: 6px;

  ::v-deep .el-button {
    flex: 1;
    margin-left: 0;
    padding: 7px 6px;
    font-size: 12px;
  }
}

.tree-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #fff;
  min-height: 300px;
  height: 100%;

  /* 极简滚动条样式 */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 2px;
  }

  /* 鼠标悬停时显示滚动条 */
  &::-webkit-scrollbar {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover::-webkit-scrollbar {
    opacity: 1;
  }

  /* Firefox滚动条 */
  scrollbar-width: thin;
  scrollbar-color: #dcdfe6 transparent;
}

.rightArea {
  margin-left: 10px;
  width: 81.5%;
  border-radius: 5px;
  overflow: hidden;
}

.p-20 {
  padding: 20px;
}

.chart-wrapper {
  height: 620px;
  width: 100%;
}

/* 树节点样式优化 */
::v-deep .el-tree {
  padding: 4px 8px;
  min-height: 100%;
}

::v-deep .el-tree-node {
  margin-bottom: 1px;
}

::v-deep .el-tree-node__content {
  height: 34px;
  line-height: 34px;
  border-radius: 3px;
  transition: all 0.2s;
  padding: 0 6px;
}

::v-deep .el-tree-node__content:hover {
  background-color: #f8f9fa;
}

::v-deep .el-tree-node.is-current>.el-tree-node__content {
  background-color: #f0f7ff;
  color: #409eff;
}

::v-deep .el-tree-node__label {
  font-size: 13px;
  user-select: none;
}

::v-deep .el-tree-node__expand-icon {
  color: #c0c4cc;
  font-size: 12px;
}

::v-deep .el-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}

/* 加载状态样式 */
::v-deep .el-tree__empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
  font-size: 13px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .my-tree {
    width: 22%;
  }

  .right-content {
    width: 77%;
  }
}

@media (max-width: 992px) {
  .app-container1 {
    flex-direction: column;
    height: auto;
  }

  .my-tree {
    width: 100%;
    margin-bottom: 10px;
    height: 400px;
  }

  .right-content {
    width: 100%;
    margin-left: 0;
  }
}
</style>
